<template>
  <div class="userdetails">
    <loading-screen v-if="loading" />
    <div class="header">
      <img @click="() => { $router.go(-1) }" src="@/assets/arrow-left.svg" />
      <span class="amount">
        {{(order_price / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })}}
      </span>
    </div>
    <div class="card">
      <h1>Persoonsgegevens</h1>
      <p v-if="campaign.prefill_address">
        Controleer deze gegevens goed en pas ze indien nodig aan.
      </p>
      <div v-if="allows_anonymous" @click="() => {anon = !anon}" class="c-checkmark">
        <label class="box">Ik wil anoniem doneren
          <span v-if="anon" class="checkmark">✓</span>
          <span v-else class="checkbox"></span>
        </label>
        <div v-if="anon">
            <div class="row anon-row">
              <p>Uw donatie kan afgerond worden door op de “{{confirmText}}” knop te drukken onderaan de pagina </p>
            </div>
          </div>
      </div>
      <p v-else>Vul deze gegevens in.</p>
      <br />
      <div v-if="!anon">
        <label for="name">Naam* (bv. F.J. van Voorbeeld):</label>
        <input name="name" v-model="customer.name" placeholder="Naam" :disabled="anon" />
        <div class="error" v-if="$v.customer.name.$error">Naam is verplicht</div>

        <label v-if="campaign.email_should_send || campaign.email_is_required" for="email">E-mail:</label>
        <input v-if="campaign.email_should_send || campaign.email_is_required" name="email" id="email"
         type="email" v-model="customer.email" placeholder="E-mail" :disabled="anon" />
        <div class="error" v-if="$v.customer.email.$error">E-mail is niet geldig</div>

        <label for="street">Straat*:</label>
        <input name="street" v-model="customer.street" placeholder="Straat" :disabled="anon"/>
        <div class="error" v-if="$v.customer.street.$error">Straat is verplicht</div>

        <div class="row house_number">
          <div class="col-8 col-8-sm">
            <label for="house_number">Huisnummer*:</label>
            <input name="house_number" v-model="customer.house_number"
              type="number" placeholder="Huisnummer" :disabled="anon"/>
          </div>
          <div class="col-4 col-4-sm">
            <label class="housenumberextra" for="house_number">Toevoeging:</label>
            <input v-model="customer.house_number_extra" placeholder="a" :disabled="anon"/>
          </div>
        </div>
        <div class="error" v-if="$v.customer.house_number.$error">
          Huisnummer is verplicht</div>

        <label for="zip">Postcode* (bv. 1111 AA):</label>
        <input name="zip" v-model="customer.zip" maxlength="7" placeholder="Postcode" :disabled="anon" />
        <div class="error" v-if="$v.customer.zip.$error">Postcode is verplicht</div>

        <label for="city">Woonplaats*:</label>
        <input name="city" v-model="customer.city" placeholder="Woonplaats" :disabled="anon"/>
        <div class="error" v-if="$v.customer.city.$error">Woonplaats is verplicht</div>

        <span>* Deze velden zijn verplicht</span>
      </div>
    </div>

    <bottom-button state="text" :text="confirmText" @clicked="submit" />
  </div>
</template>

<script>
import BottomButton from '@/components/Bottom-Button.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import { required, email } from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  name: 'UserDetails',
  components: {
    BottomButton,
    LoadingScreen,
  },
  validations() {
    // customer: {
    //   name: !this.anon ? { required } : {},
    //   street: !this.anon ? { required } : {},
    //   house_number: !this.anon ? { required } : {},
    //   zip: !this.anon ? { required } : {},
    //   city: !this.anon ? { required } : {},
    //   email: !this.anon ? { required } : {},
    // },
    if (this.anon) {
      return {
        customer: {
          name: {},
          street: {},
          house_number: {},
          zip: {},
          city: {},
          email: {},
        },
      };
    }
    return {
      customer: {
        name: { required },
        street: { required },
        house_number: { required },
        zip: { required },
        city: { required },
        email: { email },
      },
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.customer.$error) {
        this.$store.dispatch('application/postOrder');
      }
    },
  },
  data() {
    return {
      loading: true,
      anon: false,
    };
  },
  mounted() {
    if (this.campaign.id) {
      this.loading = false;
    } else {
      this.$router.push({ name: 'qr_code' });
    }
  },
  watch: {
    campaign() {
      document.title = `${this.campaign.title} - QR Direct`;
    },
  },
  computed: {
    allows_anonymous() {
      return this.campaign.donation_allow_anonymous;
    },
    campaign() {
      return this.$store.getters['application/getCampaign'];
    },
    order_price() {
      return this.$store.getters['application/getOrderPrice'];
    },
    customer() {
      return this.$store.getters['application/getCustomer'];
    },
    image_url() {
      if (this.campaign.image) {
        return `${axios.defaults.baseURL}${this.campaign.image}`;
      }
      return '';
    },
    confirmText() {
      let type = 'bestelling';
      if (this.campaign.type === 'donation') {
        type = 'donatie';
      }
      return `Bevestig ${type}`;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/colors.scss';
.userdetails {
  padding-top: calc(56px + 4vh);

  .c-checkmark label {
    font-size: 17px;
    padding-top: 4px;
  }
  .header {
    background-color: $white;
    height: 56px;
    width: 100%;
    position: fixed;
    top: 0;
    img {
      margin: 15px;
      color: $gray-dark;
    }
    .amount {
      float: right;
      margin: 17px;
      font-weight: bold;
    }
  }
  .card {
    margin-top: 0;
  }
  table {
    text-align: left;
    th {
      padding-right: 10px;
    }
  }
  .house_number {
    .col-8-sm {
      padding-left: 0;
    }
    .col-4-sm {
      padding-right: 0;
    }
  }
  .housenumberextra {
    color: rgba(44, 62, 80, 0.5);
  }
  input {
    padding: 13px 5px;
    margin: 5px auto;
    padding-left: 15px;
    width: 100%;
    background-color: $gray + #222;
    border: none;
    font-size: 12pt;
    &:focus {
      outline: none;
    }
  }
  .error {
    color: $pink;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  input:disabled {
    background-color: #D0D0D1;
  }
}
</style>
